import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectRefreshToken } from '../../store/user/selectors';
import userApi from '../../api/userApi';
import { StyledContainer, StyledLoader } from './styled';

type PropsType = {
  children: ReactNode;
};

const UserDataBoundary = ({ children }: PropsType) => {
  const token = useSelector(selectRefreshToken);

  const { isLoading } = userApi.useGetUserInfoQuery(undefined, {
    skip: !token,
  });

  if (isLoading) {
    return (
      <StyledContainer>
        <StyledLoader />
      </StyledContainer>
    );
  }

  return <>{children}</>;
};

export default UserDataBoundary;
